import type { RouteObject } from "react-router-dom";
import BaseLayout from "@/components/layout/BaseLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import DemandsPage from "@/pages/demands/page";
import DemandDetailPage from "@/pages/demands/detail/page";
import JobDetailPage from "@/pages/jobs/detail/page";
import DistributionPage from "@/pages/distribution/page";
import AuthPage from "@/pages/auth/page";
import CertificationPage from "@/pages/certification/page";
import ProfilePage from "@/pages/profile/page";
import MyResumePage from "@/pages/my-resume/page";
import MyJobResumePage from "@/pages/my-job-resume/page";
import ProviderProfilePage from "@/pages/provider-profile/page";
import BillingProfilePage from "@/pages/billing-profile/page";
import ContractsPage from "@/pages/contracts/page";
import SettingsPage from "@/pages/settings/page";
import PostDemandPage from "@/pages/post-demand/page";
import LeadSubmitPage from "@/pages/leads-submit/page";
import ProjectsPage from "@/pages/projects/page";
import ProjectDetailPage from "@/pages/projects/detail/page";
import ApplyPage from "@/pages/apply/page";
import ApplicationsPage from "@/pages/applications/page";
import ApplicationDetailPage from "@/pages/applications/detail/page";
import MyPostingsPage from "@/pages/my-postings/page";
import MyDemandDetailPage from "@/pages/my-demands/detail/page";
import MyLeadsPage from "@/pages/my-leads/page";
import NotificationsPage from "@/pages/notifications/page";
import RevenuePage from "@/pages/revenue/page";
import OrdersPage from "@/pages/orders/page";
import PointTransactionsPage from "@/pages/point-transactions/page";
import Page403 from "@/pages/error/page403";
import AuthGuard from "@/components/feature/AuthGuard";
import CoursesPage from "@/pages/courses/page";
import CourseFavoritesPage from "@/pages/courses/favorites/page";
import CourseDetailPage from "@/pages/courses/detail/page";
import TalentsPage from "@/pages/talents/page";
import TalentDetailPage from "@/pages/talents/detail/page";
import CommunityPage from "@/pages/community/page";
import CommunityDetailPage from "@/pages/community/detail/page";
import SupportTicketsPage from "@/pages/support-tickets/page";
import MyBidsPage from "@/pages/my-bids/page";
import PostJobPage from "@/pages/post-job/page";
import MyJobPostingsPage from "@/pages/my-job-postings/page";

const routes: RouteObject[] = [
  {
    element: <BaseLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/demands", element: <DemandsPage /> },
      { path: "/demands/:id", element: <DemandDetailPage /> },
      { path: "/jobs/:id", element: <JobDetailPage /> },
      { path: "/job-postings/:id", element: <JobDetailPage /> },
      { path: "/distribution", element: <DistributionPage /> },
      { path: "/auth", element: <AuthPage /> },
      { path: "/post-demand", element: <AuthGuard><PostDemandPage /></AuthGuard> },
      { path: "/post-job", element: <AuthGuard><PostJobPage /></AuthGuard> },
      { path: "/leads/submit/:id", element: <AuthGuard><LeadSubmitPage /></AuthGuard> },
      { path: "/projects", element: <AuthGuard><ProjectsPage /></AuthGuard> },
      { path: "/projects/:id", element: <AuthGuard><ProjectDetailPage /></AuthGuard> },
      { path: "/apply", element: <AuthGuard><ApplyPage /></AuthGuard> },
      { path: "/applications", element: <AuthGuard><ApplicationsPage /></AuthGuard> },
      { path: "/applications/:id", element: <AuthGuard><ApplicationDetailPage /></AuthGuard> },
      { path: "/my-leads", element: <AuthGuard><MyLeadsPage /></AuthGuard> },
      { path: "/notifications", element: <AuthGuard><NotificationsPage /></AuthGuard> },
      { path: "/courses", element: <CoursesPage /> },
      { path: "/courses/favorites", element: <AuthGuard><CourseFavoritesPage /></AuthGuard> },
      { path: "/courses/:id", element: <CourseDetailPage /> },
      { path: "/talents", element: <TalentsPage /> },
      { path: "/talents/:id", element: <TalentDetailPage /> },
      { path: "/community", element: <CommunityPage /> },
      { path: "/community/:id", element: <CommunityDetailPage /> },
      { path: "/403", element: <Page403 /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  // 账号中心通用布局组件 (内置侧边栏和 Footer)
  { path: "/support-tickets", element: <AuthGuard><SupportTicketsPage /></AuthGuard> },
  { path: "/certification", element: <AuthGuard><CertificationPage /></AuthGuard> },
  { path: "/profile", element: <AuthGuard><ProfilePage /></AuthGuard> },
  { path: "/my-resume", element: <AuthGuard><MyResumePage /></AuthGuard> },
  { path: "/my-job-resume", element: <AuthGuard><MyJobResumePage /></AuthGuard> },
  { path: "/provider-profile", element: <AuthGuard><ProviderProfilePage /></AuthGuard> },
  { path: "/billing-profile", element: <AuthGuard><BillingProfilePage /></AuthGuard> },
  { path: "/contracts", element: <AuthGuard><ContractsPage /></AuthGuard> },
  { path: "/settings", element: <AuthGuard><SettingsPage /></AuthGuard> },
  { path: "/my-postings", element: <AuthGuard><MyPostingsPage /></AuthGuard> },
  { path: "/my/job-postings", element: <AuthGuard><MyJobPostingsPage /></AuthGuard> },
  { path: "/my-job-postings", element: <AuthGuard><MyJobPostingsPage /></AuthGuard> },
  { path: "/my-demands/:id", element: <AuthGuard><MyDemandDetailPage /></AuthGuard> },
  { path: "/my/demands/:id", element: <AuthGuard><MyDemandDetailPage /></AuthGuard> },
  { path: "/my-bids", element: <AuthGuard><MyBidsPage /></AuthGuard> },
  { path: "/orders", element: <AuthGuard><OrdersPage /></AuthGuard> },
  { path: "/point-transactions", element: <AuthGuard><PointTransactionsPage /></AuthGuard> },
  { path: "/revenue", element: <AuthGuard><RevenuePage /></AuthGuard> },
];

export default routes;
